import { useActiveTenancy } from "@wacht/tanstack-router";
import { useCallback } from "react";

export const usePermission = () => {
  const { orgMembership, loading } = useActiveTenancy();

  console.log(orgMembership, 'orgMembership');

  const hasPermission = useCallback(
    (permission: string) => {

      return true;
      // Check if user has organisation:admin permission - if yes, return true for all permissions
      const hasAdminPermission =
        // @ts-ignore - role type inference issue
        orgMembership?.roles.some((role) =>
          role.permissions.includes("organisation:admin"),
        ) || false;

      if (hasAdminPermission) {
        return true;
      }

      // Otherwise, check for the specific permission
      return (
        // @ts-ignore - role type inference issue
        orgMembership?.roles.some((role) =>
          role.permissions.includes(permission),
        ) || false
      );
    },
    [orgMembership],
  );

  return {
    isLoading: loading,
    hasPermission,
  };
};
